import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiltreReportingClientComponent } from './filtre-reporting-client/filtre-reporting-client.component';
import { DetailReportingClientComponent } from './detail-reporting-client/detail-reporting-client.component';
import { DetailGeneralReportingClientComponent } from './detail-general-reporting-client/detail-general-reporting-client.component';
import {ButtonModule} from 'primeng/button';
import {DropdownModule} from 'primeng/dropdown';
import {PanelModule} from 'primeng/panel';
import {FormsModule} from '@angular/forms';
import {CardModule} from 'primeng/card';
import { TableModule } from 'primeng/table';
import { MultiSelectModule } from 'primeng/multiselect';



@NgModule({
  declarations: [FiltreReportingClientComponent, DetailReportingClientComponent, DetailGeneralReportingClientComponent],
  exports: [
    DetailReportingClientComponent,
    DetailGeneralReportingClientComponent,
    FiltreReportingClientComponent
  ],
  imports: [
    CommonModule,
    DropdownModule,
    ButtonModule,
    PanelModule,
    FormsModule,
    CardModule,
    TableModule,
    MultiSelectModule
  ]
})
export class ReportingClientModule { }
